import getRoot from "./program-overview.controller.js";

const ProgramOverview = (app) => {
  app.get("/program-overview/:cycleId", getRoot);
};

export default ProgramOverview;
